import { z } from "zod";
import { SsoProvider } from "./sso-provider";
import { WorkspaceIpSettings, WorkspaceProfileUpdate } from "./workspace";
import { NpmRegistryConfig } from "./npm-registry-settings";

export const WorkspaceConfigurationUpdate = z.object({
    id: z.string(),
    ipWhitelist: WorkspaceIpSettings.optional(),
    sso: SsoProvider.optional(),
    npmRegistrySettings: NpmRegistryConfig.optional(),
    profile: WorkspaceProfileUpdate.optional(),
});

export type WorkspaceConfigurationUpdate = z.infer<typeof WorkspaceConfigurationUpdate>;
